import { isEmpty } from "lodash";

import { PRODUCTION, DEVELOPMENT, LOCAL_FIN_SCREENER } from "./const";

export function getFinScreenerUrl() {
  const REACT_ENV = process.env.NODE_ENV;
  const FINSCREENER_URL = !!process.env.REACT_APP_FIN_SCREENER_URL && process.env.REACT_APP_FIN_SCREENER_URL !== "" ? process.env.REACT_APP_FIN_SCREENER_URL : LOCAL_FIN_SCREENER;
  if (!isEmpty(REACT_ENV)) {
    switch (REACT_ENV) {
      case DEVELOPMENT:
        return FINSCREENER_URL;
      case PRODUCTION:
        return FINSCREENER_URL;
      default:
        return FINSCREENER_URL;
    }
  } else {
    return LOCAL_FIN_SCREENER;
  }
}

export const getFinScreenerUrlValue = () => {
  return `${getFinScreenerUrl()}`;
};
